module.exports = __webpack_public_path__ + "img/loading.3d757f6c.svg";